import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/linha-do-tempo',
		component: Base,
		children: [
			{
				path: '',
				name: 'LinhaDoTempoList',
				component: List,
				meta: {
					path: '/site/linha-do-tempo',
					pai: 'Site',
					title: 'Admin - Linha do Tempo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Linha do Tempo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'LinhaDoTempoNovo',
				component: Form,
				meta: {
					path: '/site/linha-do-tempo',
					pai: 'Site',
					title: 'Admin - Linha do Tempo - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Linhado Tempo',
						class: '',
						active: false,
						url: '/site/linha-do-tempo'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'LinhaDoTempoEditar',
				component: Form,
				meta: {
					path: '/site/linha-do-tempo',
					pai: 'Site',
					title: 'Admin - Linha do Tempo - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Linha doTempo',
						class: '',
						active: false,
						url: '/site/linha-do-tempo'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]